import _ from 'lodash';
import React from 'react';
import * as Styled from './styled';
import { Heading, Paragraph, Svg } from '@mlc/web-ui-toolkit';
import { chevronRight } from '@mlc/symbols';
import quickLinksItemTestIds from './QuickLinksItem.elements';

const QuickLinkItem: React.FunctionComponent<QuickLink> = (
	props: QuickLink
) => (
	<Styled.LinkSection>
		<Heading el="h3" fontSize="tiny" marginBottom={3}>
			<Styled.Anchor
				href={props.location}
				target={props.openNewTab ? '_blank' : '_self'}
				data-id={quickLinksItemTestIds.quickLink}
				analyticsId={`tql-${_.kebabCase(props.name)}`}
			>
				{props.name} <Svg symbol={chevronRight} height="13px" />
			</Styled.Anchor>
		</Heading>
		<Paragraph data-id={quickLinksItemTestIds.itemDesc}>
			{props.description}
		</Paragraph>
	</Styled.LinkSection>
);

export default QuickLinkItem;

export interface QuickLink {
	name: string;
	openNewTab: boolean;
	location: string;
	description: String;
}
